import {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import {t} from "i18next";
import { message } from "antd";
import './LibraryTab.css'
import {KEY_LIBRARY_TAB_ID, KEY_SHOW_HIDIN_CARDS} from "../../Const";
import {getImagePathWithThemeSvg} from "../../utils";

const LibraryTab = forwardRef((props:{onActiveItem:any,onSwitchItem:any,isShowChecked:any},ref)=>{
    useImperativeHandle(ref,()=>({
        onSetActiveTableId:onSetActiveTableId
    }))

    const [activeTab,setActiveTab] = useState<any>(null);

    useEffect(() => {
        let activeItem:any = getTab()[0];
        const szId = localStorage.getItem(KEY_LIBRARY_TAB_ID);
        if (szId){
            activeItem = getTab().find(p=>p.id == szId);
        }
        setActiveTab(activeItem || getTab()[0]);
        if (props.onActiveItem){
            props.onActiveItem(activeItem || getTab()[0]);
        }
    }, []);


    const getTab = ()=>{
        const arrayTab = [
            {
                id:'all',
                name:t('All'),
                icon:'tab_all',
                selectIcon:'tab_all_pressed'
            },
            {
                id:'favorites',
                name:t('favor'),
                icon:'tab_favorites',
                selectIcon:'tab_favorites_pressed'
            },
            {
                id:'published',
                name:t('Published'),
                icon:'tab_published',
                selectIcon:'tab_published_pressed'
            }
        ]
        return arrayTab;
    }

    /**
     * 设置激活的...
     * @param szActiveId
     */
    const onSetActiveTableId = (szActiveId:any)=>{
        localStorage.setItem(KEY_LIBRARY_TAB_ID,szActiveId);
        let activeItem = getTab().find(p=>p.id == szActiveId);
        setActiveTab(activeItem);
        props.onActiveItem(activeItem);
    }


    return <div className={'flex-row-vertical-center'} style={{gap:'0px 12px'}}>
        {
            getTab().map(p=>{
                return <div className={`${activeTab?.id == p.id?'project-tab-pressed':''} flex-row-vertical-center cursor-pointer`} style={{position:'relative',minHeight:'36px',padding:'0 12px'}} onClick={(e)=>{
                    const isShowHidden = localStorage.getItem(KEY_SHOW_HIDIN_CARDS) == 'true';
                    if (isShowHidden){
                        message.info(t('PleaseExitCurStatus'));
                        return;
                    }
                    if (props.isShowChecked){
                        message.info(t('PleaseExitSelectStatus'));
                        return;
                    }
                    setActiveTab(p);
                    props.onSwitchItem(p);
                    localStorage.setItem(KEY_LIBRARY_TAB_ID,p.id);
                }}>
                    <img className={'img-16'} src={getImagePathWithThemeSvg(activeTab?.id == p.id?p.selectIcon:p.icon)}/>
                    <span className={'ml-6'} style={{color:activeTab?.id == p.id?'var(--home-project-tab-pressed-color)':'var(--home-project-tab-normal-color)'}}>{p.name}</span>
                    {
                        // activeTab?.id == p.id &&
                        // <div style={{width:'100%',height:'2px',background:'var(--primary-color)',position:'absolute',left:'0',bottom:'0'}}></div>
                    }
                </div>
            })
        }
    </div>
})

export default LibraryTab;
















